import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-countdown-container',
    templateUrl: 'countdown-container.component.html',
    styleUrls: ['./countdown-container.component.scss']
})
export class CountdownContainerComponent
{
    public backgroundUrl: string;

    private router: Router;

    public constructor(router: Router)
    {
        this.router = router;
    }

    public showPage(): void
    {
        this.router.navigate(['/lodder-til-salg/lodder']);
    }
}
